import { getEditorTrackingFieldNames } from "./schemas/getEditorTrackingFields";

export default function mapSchema(jsonData, editSchema) {
  var fields = [];
  Object.keys(jsonData[0]).forEach((colName) => {
    var match = editSchema.find((f) => f.name === colName);
    if (match === undefined) {
      editSchema.forEach((fd) => {
        if (
          fd.hasOwnProperty("similair") &&
          fd.similair.includes(colName.toLowerCase())
        )
          match = fd;
      });
    }

    var availableFds = editSchema
      .filter(
        (f) =>
          f.name !== "id" &&
          !f.name.includes("_id") &&
          getEditorTrackingFieldNames().includes(f.name) === false,
      )
      .map((f) => f.name);

    availableFds.push("New Attribute");

    fields.push({
      name: colName,
      selected: match ? match.name : "New Attribute",
      options: availableFds,
      attribute: colName,
      error: false,
    });
  });
  return fields;
}
